var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 10c0-5.522-4.478-10-10-10S0 4.478 0 10s4.478 10 10 10 10-4.478 10-10Zm-8.804 2.139H8.35v-.285c0-.484.052-.877.162-1.18a2.66 2.66 0 0 1 .49-.83c.218-.25.708-.689 1.467-1.32.403-.33.607-.632.607-.905 0-.279-.083-.49-.244-.643-.163-.151-.409-.228-.74-.228-.356 0-.647.119-.878.352-.233.234-.381.646-.446 1.23l-2.91-.361c.099-1.07.488-1.93 1.163-2.58.68-.654 1.718-.978 3.116-.978 1.09 0 1.97.228 2.638.682.912.615 1.364 1.435 1.364 2.457 0 .427-.119.837-.352 1.23-.234.398-.714.878-1.44 1.446-.503.404-.822.723-.954.965-.132.241-.197.559-.197.948Zm-2.947.76h3.053v2.69H8.25V12.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.e98117bc02ee1a2fc9dd9b9897a35918.svg";
export { ForwardRef as ReactComponent };